/**
 * Generated by Orval
 * Do not edit manually.
 * Sell To API
 * OpenAPI spec version: v3
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  InvalidateOptions,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateRnmRequestRequest,
  EntitiesRnmRequestCollectionMain,
  EntitiesRnmRequestMemberMain,
  UpdateRnmRequestRequest
} from '../../models';

import { customInstance } from '../../../../services/api';
import type { ErrorType } from '../../../../services/api';
import { customQueryOptions } from '../../../../mutators/customQueryOptions';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Download RNM form template
 */
export const downloadRnmRequestTemplate = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown>(
      {url: `/api/v3/rnm_requests/download_template`, method: 'GET', signal
    },
      options);
    }




export const getDownloadRnmRequestTemplateInfiniteQueryKey = () => {
    return [
    'infinite', `/api/v3/rnm_requests/download_template`
    ] as const;
    }

export const getDownloadRnmRequestTemplateQueryKey = () => {
    return [
    `/api/v3/rnm_requests/download_template`
    ] as const;
    }


export const useDownloadRnmRequestTemplateInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadRnmRequestTemplateInfiniteQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>> = ({ signal }) => downloadRnmRequestTemplate(requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadRnmRequestTemplateInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>>
export type DownloadRnmRequestTemplateInfiniteQueryError = ErrorType<unknown>


export function useDownloadRnmRequestTemplateInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadRnmRequestTemplate>>,
          TError,
          Awaited<ReturnType<typeof downloadRnmRequestTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadRnmRequestTemplateInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadRnmRequestTemplate>>,
          TError,
          Awaited<ReturnType<typeof downloadRnmRequestTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadRnmRequestTemplateInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download RNM form template
 */

export function useDownloadRnmRequestTemplateInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useDownloadRnmRequestTemplateInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Download RNM form template
 */
export const prefetchDownloadRnmRequestTemplateInfiniteQuery = async <TData = Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient,  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useDownloadRnmRequestTemplateInfiniteQueryOptions(options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useDownloadRnmRequestTemplateInfinite} query
 */
export const invalidateDownloadRnmRequestTemplateInfinite = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getDownloadRnmRequestTemplateInfiniteQueryKey() }).queryKey }, options);

  return queryClient;
}




export const useDownloadRnmRequestTemplateQueryOptions = <TData = Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadRnmRequestTemplateQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>> = ({ signal }) => downloadRnmRequestTemplate(requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadRnmRequestTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>>
export type DownloadRnmRequestTemplateQueryError = ErrorType<unknown>


export function useDownloadRnmRequestTemplate<TData = Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadRnmRequestTemplate>>,
          TError,
          Awaited<ReturnType<typeof downloadRnmRequestTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadRnmRequestTemplate<TData = Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadRnmRequestTemplate>>,
          TError,
          Awaited<ReturnType<typeof downloadRnmRequestTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadRnmRequestTemplate<TData = Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download RNM form template
 */

export function useDownloadRnmRequestTemplate<TData = Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useDownloadRnmRequestTemplateQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Download RNM form template
 */
export const prefetchDownloadRnmRequestTemplateQuery = async <TData = Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useDownloadRnmRequestTemplateQueryOptions(options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useDownloadRnmRequestTemplate} query
 */
export const invalidateDownloadRnmRequestTemplate = async (
 queryClient: QueryClient,  options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getDownloadRnmRequestTemplateQueryKey() }).queryKey }, options);

  return queryClient;
}




export const useDownloadRnmRequestTemplateSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadRnmRequestTemplateQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>> = ({ signal }) => downloadRnmRequestTemplate(requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadRnmRequestTemplateSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>>
export type DownloadRnmRequestTemplateSuspenseQueryError = ErrorType<unknown>


export function useDownloadRnmRequestTemplateSuspense<TData = Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadRnmRequestTemplateSuspense<TData = Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadRnmRequestTemplateSuspense<TData = Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download RNM form template
 */

export function useDownloadRnmRequestTemplateSuspense<TData = Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useDownloadRnmRequestTemplateSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useDownloadRnmRequestTemplateSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadRnmRequestTemplateInfiniteQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>> = ({ signal }) => downloadRnmRequestTemplate(requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadRnmRequestTemplateSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>>
export type DownloadRnmRequestTemplateSuspenseInfiniteQueryError = ErrorType<unknown>


export function useDownloadRnmRequestTemplateSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadRnmRequestTemplateSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadRnmRequestTemplateSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download RNM form template
 */

export function useDownloadRnmRequestTemplateSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadRnmRequestTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useDownloadRnmRequestTemplateSuspenseInfiniteQueryOptions(options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Create RNM request
 */
export const createRnmRequest = (
    createRnmRequestRequest: CreateRnmRequestRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesRnmRequestCollectionMain>(
      {url: `/api/v3/rnm_requests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createRnmRequestRequest, signal
    },
      options);
    }




export const getCreateRnmRequestMutationKey = () => ['createRnmRequest'] as const;

export const getCreateRnmRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRnmRequest>>, TError,CreateRnmRequestMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createRnmRequest>>, TError,CreateRnmRequestMutationVariables, TContext> => {

const mutationKey = getCreateRnmRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRnmRequest>>, CreateRnmRequestMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createRnmRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRnmRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createRnmRequest>>>
    export type CreateRnmRequestMutationBody = CreateRnmRequestRequest
    export type CreateRnmRequestMutationError = ErrorType<unknown>
    export type CreateRnmRequestMutationVariables = {data: CreateRnmRequestRequest}

    /**
 * @summary Create RNM request
 */
export const useCreateRnmRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRnmRequest>>, TError,CreateRnmRequestMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRnmRequest>>,
        TError,
        CreateRnmRequestMutationVariables,
        TContext
      > => {
      return useMutation(getCreateRnmRequestMutationOptions(options), queryClient);
    }
    /**
 * @summary Show RNM request
 */
export const showRnmRequest = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesRnmRequestMemberMain>(
      {url: `/api/v3/rnm_requests/${id}`, method: 'GET', signal
    },
      options);
    }




export const getShowRnmRequestInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/api/v3/rnm_requests/${id}`
    ] as const;
    }

export const getShowRnmRequestQueryKey = (id: number,) => {
    return [
    `/api/v3/rnm_requests/${id}`
    ] as const;
    }


export const useShowRnmRequestInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof showRnmRequest>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowRnmRequestInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showRnmRequest>>> = ({ signal }) => showRnmRequest(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowRnmRequestInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof showRnmRequest>>>
export type ShowRnmRequestInfiniteQueryError = ErrorType<unknown>


export function useShowRnmRequestInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showRnmRequest>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof showRnmRequest>>,
          TError,
          Awaited<ReturnType<typeof showRnmRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowRnmRequestInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showRnmRequest>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof showRnmRequest>>,
          TError,
          Awaited<ReturnType<typeof showRnmRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowRnmRequestInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showRnmRequest>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show RNM request
 */

export function useShowRnmRequestInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showRnmRequest>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowRnmRequestInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Show RNM request
 */
export const prefetchShowRnmRequestInfiniteQuery = async <TData = Awaited<ReturnType<typeof showRnmRequest>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useShowRnmRequestInfiniteQueryOptions(id,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useShowRnmRequestInfinite} query
 */
export const invalidateShowRnmRequestInfinite = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getShowRnmRequestInfiniteQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useShowRnmRequestQueryOptions = <TData = Awaited<ReturnType<typeof showRnmRequest>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowRnmRequestQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showRnmRequest>>> = ({ signal }) => showRnmRequest(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowRnmRequestQueryResult = NonNullable<Awaited<ReturnType<typeof showRnmRequest>>>
export type ShowRnmRequestQueryError = ErrorType<unknown>


export function useShowRnmRequest<TData = Awaited<ReturnType<typeof showRnmRequest>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof showRnmRequest>>,
          TError,
          Awaited<ReturnType<typeof showRnmRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowRnmRequest<TData = Awaited<ReturnType<typeof showRnmRequest>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof showRnmRequest>>,
          TError,
          Awaited<ReturnType<typeof showRnmRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowRnmRequest<TData = Awaited<ReturnType<typeof showRnmRequest>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show RNM request
 */

export function useShowRnmRequest<TData = Awaited<ReturnType<typeof showRnmRequest>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowRnmRequestQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Show RNM request
 */
export const prefetchShowRnmRequestQuery = async <TData = Awaited<ReturnType<typeof showRnmRequest>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useShowRnmRequestQueryOptions(id,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useShowRnmRequest} query
 */
export const invalidateShowRnmRequest = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getShowRnmRequestQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useShowRnmRequestSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof showRnmRequest>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowRnmRequestQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showRnmRequest>>> = ({ signal }) => showRnmRequest(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowRnmRequestSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof showRnmRequest>>>
export type ShowRnmRequestSuspenseQueryError = ErrorType<unknown>


export function useShowRnmRequestSuspense<TData = Awaited<ReturnType<typeof showRnmRequest>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowRnmRequestSuspense<TData = Awaited<ReturnType<typeof showRnmRequest>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowRnmRequestSuspense<TData = Awaited<ReturnType<typeof showRnmRequest>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show RNM request
 */

export function useShowRnmRequestSuspense<TData = Awaited<ReturnType<typeof showRnmRequest>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowRnmRequestSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useShowRnmRequestSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof showRnmRequest>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowRnmRequestInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showRnmRequest>>> = ({ signal }) => showRnmRequest(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowRnmRequestSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof showRnmRequest>>>
export type ShowRnmRequestSuspenseInfiniteQueryError = ErrorType<unknown>


export function useShowRnmRequestSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showRnmRequest>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowRnmRequestSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showRnmRequest>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowRnmRequestSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showRnmRequest>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show RNM request
 */

export function useShowRnmRequestSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showRnmRequest>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showRnmRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowRnmRequestSuspenseInfiniteQueryOptions(id,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update RNM request
 */
export const updateRnmRequest = (
    id: number,
    updateRnmRequestRequest?: UpdateRnmRequestRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesRnmRequestMemberMain>(
      {url: `/api/v3/rnm_requests/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateRnmRequestRequest, signal
    },
      options);
    }




export const getUpdateRnmRequestMutationKey = () => ['updateRnmRequest'] as const;

export const getUpdateRnmRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRnmRequest>>, TError,UpdateRnmRequestMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRnmRequest>>, TError,UpdateRnmRequestMutationVariables, TContext> => {

const mutationKey = getUpdateRnmRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRnmRequest>>, UpdateRnmRequestMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateRnmRequest(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRnmRequestMutationResult = NonNullable<Awaited<ReturnType<typeof updateRnmRequest>>>
    export type UpdateRnmRequestMutationBody = UpdateRnmRequestRequest | undefined
    export type UpdateRnmRequestMutationError = ErrorType<unknown>
    export type UpdateRnmRequestMutationVariables = {id: number;data?: UpdateRnmRequestRequest}

    /**
 * @summary Update RNM request
 */
export const useUpdateRnmRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRnmRequest>>, TError,UpdateRnmRequestMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateRnmRequest>>,
        TError,
        UpdateRnmRequestMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateRnmRequestMutationOptions(options), queryClient);
    }
